<template>
  <v-menu v-model="userMenuOpen" offset-y left>
    <template v-slot:activator="{ on }">
      <v-btn tile icon v-on="on">
        <v-avatar height="44" width="33" tile>
          <img :src="userImageSrc" :alt="getUserNameFromToken()" />
        </v-avatar>
      </v-btn>
    </template>

    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            class="font-weight-bold"
            v-text="getUserNameFromToken()"
          />
          <v-list-item-subtitle
            class="font-weight-thin"
            v-text="getUserEmailFromToken()"
          />
        </v-list-item-content>
      </v-list-item>
      <v-divider />

      <v-list-item to="/config/userprofile" link>
        <v-list-item-title v-t="'Components.MetalinkNavigation.MyProfile'" />
      </v-list-item>

      <v-list-item
        v-if="canImpersionate()"
        to="/security/user-impersonation"
        link
      >
        <v-list-item-title v-t="'Components.MetalinkNavigation.Impersonate'" />
      </v-list-item>

      <v-list-item @click="logout()">
        <v-list-item-title v-t="'Components.MetalinkNavigation.Logout'" />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { keycloakLogout, keycloak } from "@/config/keycloak/keycloak";
import {
  getUserName,
  getUserEmail,
  hasManagementRole
} from "@/config/keycloak/keycloakUser";
import { navigationBus } from "+/components/navigation/utils/navigationBus.js";
import { mapGetters } from "vuex";
import { isUserImpersoniated } from "@/config/keycloak/keycloakUser";

export default {
  data() {
    return {
      userMenuOpen: false
    };
  },
  computed: { ...mapGetters("userProfile", { userImageSrc: "userImageSrc" }) },
  created() {
    window.addEventListener("message", this.closeUserMenu, false);
  },
  methods: {
    canImpersionate() {
      return (
        this.hasImpersonationRole() &&
        this.hasManageUsersRole() &&
        !this.userIsImpersoniated()
      );
    },
    closeUserMenu(event) {
      if (event.data == "mainIframeClick") {
        this.userMenuOpen = false;
      }
    },
    logout() {
      navigationBus.$emit("navigation-item-click");
      keycloakLogout(
        function() {
          window.location.href = keycloak.createLogoutUrl({
            redirectUri: window.location.origin
          });
        },
        null,
        true
      );
    },
    hasImpersonationRole() {
      return hasManagementRole("impersonation");
    },
    hasManageUsersRole() {
      return hasManagementRole("manage-users");
    },
    userIsImpersoniated() {
      return isUserImpersoniated();
    },
    getUserNameFromToken() {
      return getUserName();
    },
    getUserEmailFromToken() {
      return getUserEmail();
    }
  }
};
</script>
